import { mapGetters } from 'vuex';
import { postAPICall } from '../helpers/httpHelper';
import { fetchEntityById } from '../repo/entityRepo';
import { getAllFieldsArrayFromEntity } from '@/utils/formatter';
import { fetchSingleCompanyTemplate } from '../repo/templatesRepo';
export default {
  data() {
    return {
      operatorsMap: {
        BOOLEAN: [
          {
            title: 'YES',
            value: 'Yes',
          },
          {
            title: 'NO',
            value: 'no',
          },
        ],
        QUESTION: [
          {
            title: 'YES',
            value: 'YES',
          },
          {
            title: 'NO',
            value: 'NO',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
        ],

        CHECKBOX: [
          {
            title: 'CHECKED',
            value: 'Checked',
          },
          {
            title: 'UNCHECKED',
            value: 'Unchecked',
          },
        ],
        RADIO: [
          {
            title: 'CHECKED',
            value: 'Checked',
          },
          {
            title: 'UNCHECKED',
            value: 'Unchecked',
          },
        ],
        NUMBER: [
          {
            title: 'Equals (=)',
            value: '=',
          },
          {
            title: ' Not Equals (!=)',
            value: '!=',
          },
          {
            title: 'Greater Than (>)',
            value: '>',
          },
          {
            title: 'Greater Than or Equal(>=)',
            value: '>=',
          },
          {
            title: 'Less Than (<)',
            value: '<',
          },
          {
            title: 'Less Than or Equal(<=)',
            value: '<=',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Between',
            value: 'between',
          },
        ],
        TIME_RANGE: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        IMAGE: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        VIDEO: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        CAPTCHA: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        DATE_RANGE: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'range',
            value: 'ranges',
          },
        ],
        WEEKDAYS: [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        SIGNATURE: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],

        STRING: [
          {
            title: 'Equals (Case-sensitive)',
            value: '=case-sensitive',
          },
          {
            title: 'Not Equals (Case-sensitive)',
            value: '!=case-sensitive',
          },
          {
            title: 'Equals (Case-insensitive)',
            value: '=case-insensitive',
          },
          {
            title: 'Not Equals (Case-insensitive)',
            value: '!=case-insensitive',
          },
          {
            title: 'Starts With',
            value: '=starts-with',
          },
          {
            title: ' Not Starts With',
            value: '=not-starts-with',
          },
          {
            title: 'Ends With',
            value: '=ends-with',
          },
          {
            title: 'Not Ends With',
            value: '!ends-with',
          },
          {
            title: 'Text Includes',
            value: '=text-includes',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
        ],

        OBJECT_ID: [
          {
            title: 'Value Changes',
            value: 'value_changes',
          },
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
        ],

        TIME: [
          {
            title: 'Equals (=)',
            value: '=',
          },
          {
            title: 'Greater Than (>)',
            value: '>',
          },
          {
            title: 'Greater Than or Equal(>=)',
            value: '>=',
          },
          {
            title: 'Less Than (<)',
            value: '<',
          },
          {
            title: 'Less Than or Equal(<=)',
            value: '<=',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
        ],
        RELATION: [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ],
        FILE: [
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
        ],
        SLOT: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        ARRAY: [
          {
            title: 'In',
            value: 'in',
          },

          {
            title: 'Not In',
            value: 'nin',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        DATE_TIME: [
          {
            title: 'Greater Than (>)',
            value: '>',
          },

          {
            title: 'Less Than (<)',
            value: '<',
          },
          {
            title: 'Equals (=)',
            value: '=',
          },

          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
        ],
        DATE: [
          {
            title: 'Equals (=)',
            value: '=',
          },
          {
            title: 'Not Equals (=)',
            value: '!=',
          },
          {
            title: 'Greater Than (>)',
            value: '>',
          },
          {
            title: 'Greater Than or Equal(>=)',
            value: '>=',
          },
          {
            title: 'Less Than (<)',
            value: '<',
          },
          {
            title: 'Less Than or Equal(<=)',
            value: '<=',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'range',
            value: 'ranges',
          },
        ],
        ACTION: [
          {
            title: 'Click',
            value: 'click',
          },
          {
            title: 'Label Matches',
            value: 'labelmatch',
          },
        ],
        PHONE: [
          {
            title: 'Exist',
            value: 'exists',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
        PAYMENT: [
          {
            title: 'Equals (Case-sensitive)',
            value: '=case-sensitive',
          },
          {
            title: 'Equals (Case-insensitive)',
            value: '=case-insensitive',
          },
          {
            title: 'Not Exist',
            value: 'notexists',
          },
        ],
      },
      allowedFieldTypes: [
        'SINGLE_LINE_TEXT',
        'LOCATION',
        'IMAGE',
        'VIDEO',
        'FILE',
        'MULTI_LINE_TEXT',
        'DATE',
        'SELECT',
        'SLOT',
        'INTEGRATION_VARIABLE',
        'NUMBER',
        'MULTI_SELECT',
        'CURRENCY',
        'YES_OR_NO',
        'CHECKBOX',
        'CHECKBOX_GROUP',
        'FORMULA',
        'ENTITY',
        'INTEGRATION',
        'WEEKDAYS',
        'RADIO',
        'RADIO_BUTTON_GROUP',
        'ACTION_BUTTON',
        'LIST',
        'TIME',
        'GLOBAL_VARIABLE',
        'DATE_TIME',
        'AGGREGATE_FUNCTION',
        'PHONE_COUNTRY_CODE',
        'DATE_RANGE',
        'STAR_RATING',
        'PAY_BUTTON',
        'AUTO_INCREMENT_NUMBER',
        'DATA_TABLE',
        'ENTITY_VARIABLE',
        'SIGNATURE',
        'ENTITY_TABLE',
        'CAPTCHA',
        'QUESTION',
        'CONCATENATE',
      ],
      selectedFieldsKey: '',
      weekdayOptions: [
        { name: 'Monday', value: 'MON' },
        { name: 'Tuesday', value: 'TUE' },
        { name: 'Wednesday', value: 'WED' },
        { name: 'Thursday', value: 'THU' },
        { name: 'Friday', value: 'FRI' },
        { name: 'Saturday', value: 'SAT' },
        { name: 'Sunday', value: 'SUN' },
      ],
      starRating_options: [
        { name: '1', value: 1 },
        { name: '1.5', value: 1.5 },
        { name: '2', value: 2 },
        { name: '2.5', value: 2.5 },
        { name: '3', value: 3 },
        { name: '3.5', value: 3.5 },
        { name: '4', value: 4 },
        { name: '4.5', value: 4.5 },
        { name: '5', value: 5 },
      ],
      ruleIntegrationOptions: {},
      operatorValueTypeMap: [
        {
          value_type: 'VALUE',

          operators: [
            'labelmatch',
            'value_changes',
            '=',
            '<=',
            '<',
            '>',
            '>=',
            '=case-insensitive',
            '=case-sensitive',
            '!=case-insensitive',
            '!=case-sensitive',
            '=text-includes',
            '!ends-with',
            'dateinclude',
            '=starts-with',
            '=ends-with',
            '=not-starts-with',
            '!=',
            'between',
            'ranges',
            'changelabel',
          ],
          data_types: [
            'NUMBER',
            'STRING',
            'DATE',
            'TIME',
            'DATE_TIME',
            'BOOLEAN',
            'CHECKBOX_GROUP',
            'ARRAY',
            'PHONE',
            'created_at',
            'updated_at',
            'changelabel',
            'ACTION',
          ],
        },
        {
          value_type: 'NEW_LIST',
          operators: ['in', 'nin'],
          data_types: ['NUMBER', 'STRING'],
        },
        {
          value_type: 'ENTITY_DATA_LIST',
          operators: ['in', 'nin'],
          data_types: ['OBJECT_ID', 'RELATION'],
        },
        {
          value_type: 'REAL_TIME_PICKER',
          operators: ['dateinclude'],
          data_types: ['DATE'],
        },
      ],
      allowedLoginRuleOp: ['=text-includes', '=case-insensitive', '=case-sensitive'],
      loginUserFields: [
        {
          value: 'email',
          label: 'Email',
        },
        {
          value: 'first_name',
          label: 'First Name',
        },
        {
          value: 'last_name',
          label: 'Last Name',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('auth', [
      'getDefaultDateFormat',
      'getAuthenticatedUser',
      'getUserTypeList',
      'getUserType',
      'getCompanyUsers',
    ]),
    filteredEntities() {
      if (this.getAllEntities && this.getAllEntities.length) {
        return this.getAllEntities.filter(
          (user) => user.entity_type === 'BUSINESS' || user.entity_type === 'INDIVIDUAL'
        );
      } else {
        return [];
      }
    },
    entilistAsOptions() {
      return (filter) => {
        let field = this.getField(filter.selectField);
        if (field && field.entity_id && this.entityDataInfo && this.entityDataInfo.length) {
          let selectedEntity = this.entityDataInfo.find((e) => e.entity_id === field.entity_id);
          if (selectedEntity && selectedEntity.data) {
            return selectedEntity.data;
          }
        } else {
          return [];
        }
      };
    },
    includeDataTableFields() {
      let datatableFields = [],
        fields = this.allowedFields;
      fields.forEach((e) => {
        if (
          (e.inputType == 'DATA_TABLE' || e.inputType == 'ENTITY_TABLE') &&
          e.data_table_columns
        ) {
          e.data_table_columns.forEach((j) => {
            if (this.allowedFieldTypes.indexOf(j.inputType) !== -1) {
              let c = JSON.parse(JSON.stringify(j));
              if (c.key && !c.key.includes('#')) {
                c.key = e.key + '#' + c.key;
                c.label = e.label + ' - ' + c.label;
              } else if (c.key && c.key.includes('@')) {
                c.label = e.label + ' - ' + c.label;
              }
              datatableFields.push(c);
            }
          });
        }
        return e;
      });
      return [...fields, ...datatableFields];
    },
    allowedFields() {
      let groups = [];

      this.allFields.forEach((gr) => {
        if (gr?.group_key && gr.input_type === 'CHECKBOX') {
          let group = (this.checkBoxGroupArray || []).find((e) => e.key === gr.group_key);

          if (group && !groups.some((el) => el.key === group.key)) {
            groups.push({
              ...group,
              inputType: 'CHECKBOX_GROUP',
              is_individual: true,
            });
          }
        }
      });

      let filteredFields = this.allFields.filter((e) => e.inputType !== 'FILE');

      return [
        ...groups,
        ...this.allFields.filter((e) => {
          if (
            !e.group_key &&
            (this.allowedFieldTypes.includes(e.inputType) || this.isValidActionButton(e)) &&
            (filteredFields || (e.key && e.label))
          ) {
            return true;
          }
        }),
      ];
    },
  },
  methods: {
    async fetchEntityPrimaryFieldsData(entity_id) {
      if (!entity_id) {
        return;
      }
      let entity = await fetchEntityById(entity_id);
      let params = {
        entity_id: entity_id,
        template_fields_data: getAllFieldsArrayFromEntity(entity),
        format_data: true,
        filters: [],
        limit: 50,
      };

      const v2Response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
      this.entityRecordsForTableLocal = v2Response?.data;
      if (
        this.entityRecordsForTableLocal &&
        this.entityRecordsForTableLocal.data &&
        this.entityDataInfo
      ) {
        this.entityDataInfo.push({
          entity,
          data: this.entityRecordsForTableLocal.data,
          entity_id: entity_id,
        });
      }
    },
    getFieldData() {
      const entityFields = this.allFields.filter(
        (field) =>
          field.input_type === 'ENTITY' &&
          field.inputType === 'ENTITY' &&
          Array.isArray(field.primary_fields) &&
          field.primary_fields.some((pf) => pf.includes('#'))
      );

      if (!entityFields.length) {
        return null;
      }
      const matchedFields = [];

      entityFields.forEach((entityField) => {
        const primaryField = entityField.primary_fields.find((pf) => pf.includes('#'));

        if (primaryField) {
          const [primaryId, primaryKey] = primaryField.split('#');
          const matchedTemplate = this.allTemplates.find((template) => {
            return template._id === primaryId;
          });

          if (matchedTemplate) {
            const matchedField = matchedTemplate.sections[0].fields.find(
              (field) => field.key === primaryKey
            );
            if (
              matchedField &&
              matchedField.input_type === 'DATE' &&
              matchedField.inputType === 'DATE'
            ) {
              matchedFields.push({
                entityField,
                primaryId,
                primaryKey,
                matchedField,
              });
            }
          } else {
            console.log('No matched template found for Primary ID:', primaryId);
          }
        } else {
          console.log("No primary field with '#' found in", entityField);
        }
      });
      if (matchedFields.length && matchedFields[0].entityField) {
        this.entityFieldForTemplate = matchedFields[0].entityField;
        return matchedFields[0].entityField;
      }
      return null;
    },
    geTemplateFieldsByType(rule) {
      let field = this.getField(rule.selectField);

      if (field.input_type) {
        let fields = [...this.allFields, ...this.includeDataTableFields].flat();
        let uniqueFields = Array.from(new Set(fields.map((f) => f.key))).map((key) => {
          return fields.find((f) => f.key === key);
        });

        return uniqueFields.filter((e) => {
          if (field.input_type === 'ENTITY') {
            return (
              (e.inputType === 'CONCATENATE' || e.inputType === 'ENTITY') &&
              e.key !== rule.selectField
            );
          }
          if (field.input_type === 'CHECKBOX_GROUP') {
            return e.inputType === 'NUMBER';
          } else if (field.input_type === 'NUMBER' || field.input_type == 'ENTITY_TABLE') {
            return (
              (e.inputType === 'NUMBER' ||
                e.inputType === 'AGGREGATE_FUNCTION' ||
                e.inputType === 'FORMULA' ||
                e.inputType === 'CURRENCY') &&
              e.key !== rule.selectField
            );
          } else if (
            field.inputType == 'INTEGRATION_VARIABLE' &&
            field?.integration_settings?.selectedIntegrationFieldVariableType == 'text'
          ) {
            return (
              e.input_type === 'SINGLE_LINE_TEXT' ||
              (e.inputType == 'INTEGRATION_VARIABLE' &&
                e?.integration_settings?.selectedIntegrationFieldVariableType == 'text') ||
              (e.input_type === 'EMAIL' && e.key !== rule.selectField)
            );
          } else if (
            field.inputType === 'INTEGRATION' &&
            field?.integration_settings?.templateDependencies?.length > 0
          ) {
            return e?.integration_settings?.templateDependencies?.length > 0;
          } else if (
            field.inputType === 'INTEGRATION_VARIABLE' &&
            field?.integration_settings?.selectedIntegrationFieldVariableType === 'select'
          ) {
            return e?.integration_settings?.selectedIntegrationFieldVariableType === 'select';
          } else if (field.input_type === 'EMAIL' || field.input_type === 'PASSWORD') {
            return (
              e.input_type === 'SINGLE_LINE_TEXT' ||
              (e.input_type === 'EMAIL' && e.key !== rule.selectField)
            );
          } else if (
            field.input_type === 'SINGLE_LINE_TEXT' ||
            field.input_type === 'MULTI_LINE_TEXT'
          ) {
            return (
              e.input_type === 'LOCATION' ||
              (e.input_type === 'SINGLE_LINE_TEXT' && e.key !== rule.selectField)
            );
          } else if (field.input_type === 'HYPER_LINK') {
            return e.input_type === 'HYPER_LINK' && e.key !== rule.selectField;
          } else if (field.input_type === 'DATE' || field.input_type == 'INTEGRATION_VARIABLE') {
            const entityFieldForTemplate = this.getFieldData();

            return (
              (e.input_type === 'DATE' ||
                e.result_type == 'DATE' ||
                e.inputType === 'DATE_RANGE' ||
                (e.input_type == 'ENTITY_VARIABLE' && e.inputType == 'DATE') ||
                (e.input_type == 'FORMULA' &&
                  e.inputType == 'FORMULA' &&
                  e.result_type == 'NUMBER') ||
                (e.input_type == 'INTEGRATION_VARIABLE' &&
                  e?.integration_settings?.selectedIntegrationFieldVariableType == 'date') ||
                e.inputType == 'WEEKDAYS' ||
                (entityFieldForTemplate && e.key == entityFieldForTemplate.key)) &&
              e.key !== rule.selectField
            );
          } else if (field.inputType === 'AGGREGATE_FUNCTION') {
            return (
              e.inputType === 'CURRENCY' ||
              e.inputType === 'FORMULA' ||
              e.inputType === 'NUMBER' ||
              (e.inputType === 'AGGREGATE_FUNCTION' && e.key !== rule.selectField)
            );
          } else if (field.input_type === 'CURRENCY') {
            return (
              e.inputType === 'AGGREGATE_FUNCTION' ||
              e.inputType === 'FORMULA' ||
              e.input_type === 'NUMBER' ||
              (e.input_type == 'ENTITY_VARIABLE' && e.inputType == 'CURRENCY') ||
              (e.input_type === 'CURRENCY' && e.key !== rule.selectField)
            );
          } else if (field.input_type === 'FORMULA') {
            let numberTypes = ['CURRENCY', 'AGGREGATE_FUNCTION', 'NUMBER'];
            return (
              ((numberTypes.indexOf(field.result_type) !== -1 &&
                (numberTypes.indexOf(e.input_type) !== -1 ||
                  (e.input_type === 'FORMULA' && numberTypes.indexOf(e.result_type) !== -1))) ||
                field.result_type == e.inputType ||
                (e.inputType == 'FORMULA' && field.result_type == e.result_type)) &&
              e.key !== rule.selectField
            );
          } else if (field.input_type === 'ENTITY_VARIABLE') {
            return (
              (e.inputType === field.inputType || e.result_type === field.inputType) &&
              e.key !== field.key
            );
          } else if (field.input_type === 'PAYMENT_VARIABLE') {
            return e.inputType === field.inputType && e.key !== field.key;
          } else if (field.input_type === 'PAY_BUTTON') {
            return e.inputType === field.inputType && e.key !== field.key;
          } else {
            return e.inputType === field.input_type && e.key !== field.key;
          }
        });
      }
      return [];
    },
    getCurrentFieldOptions(filter) {
      if (filter.selectField === 'userType') {
        filter.data_type = 'userType';
        filter.input_type = 'userType';
        return;
      }
      if (filter.selectField === 'IsUserType') {
        filter.data_type = 'IsUserType';
        filter.input_type = 'IsUserType';
        return [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ];
      }
      if (filter.selectField) {
        let field = this.getField(filter.selectField);
        if (field && field.input_type == 'PAY_BUTTON' && field.pay_status) {
          return field.pay_status;
        }
        if (
          field?.inputType == 'INTEGRATION_VARIABLE' &&
          field?.integration_settings &&
          field?.integration_settings?.selectedIntegrationFieldVariableType == 'select'
        ) {
          return field.options;
        }
        if (field?.inputType == 'LIST' && field?.input_type == 'LIST') {
          return field.list_data;
        }
        if (field && field.options) {
          return field.options;
        } else if (field?.input_type === 'ENTITY_VARIABLE' && this.templateDataInfo) {
          let tempId = '';
          let key = '';
          if (field.global_variable_entity_field.includes('#')) {
            [tempId, key] = field.global_variable_entity_field.split('#');
          } else if (field.global_variable_entity_field.includes('~')) {
            tempId = field.global_variable_entity_field.split('~')[0];
            if (field.global_variable_entity_field.split('~')[1]) {
              key = field.global_variable_entity_field.split('~')[1];
            }
          } else if (field.global_variable_entity_field_template_id) {
            tempId = field.global_variable_entity_field_template_id;
          }
          if (field.global_variable_entity_select_type_field_key) {
            key = field.global_variable_entity_select_type_field_key;
          }
          if (this.templateDataInfo[tempId] && key) {
            const originField = this.templateDataInfo[tempId].find((el) => el.key === key);

            if (originField?.list_data && Array.isArray(originField.list_data)) {
              return originField.list_data;
            }
            return [];
          }
          return [];
        }
      } else {
        return [];
      }
    },
    filteredFields(selectedGroupKey) {
      return this.allFields.filter(
        (gr) => gr.inputType === 'CHECKBOX' && selectedGroupKey == gr.group_key
      );
    },
    checkIsMultiple(filter) {
      if (filter.selectField) {
        let field = this.getField(filter.selectField);
        if (field && field.inputType == 'WEEKDAYS') {
          return field.allow_multiple;
        }
        if (field && field.input_type == 'SELECT') {
          return true;
        }
        if (field && field.input_type == 'PAY_BUTTON') {
          return false;
        } else if (field?.input_type == 'ENTITY_VARIABLE' && this.templateDataInfo) {
          let tempId = '';
          let key = '';
          if (field.global_variable_entity_field.includes('#')) {
            [tempId, key] = field.global_variable_entity_field.split('#');
          } else if (field.global_variable_entity_field.includes('~')) {
            tempId = field.global_variable_entity_field.split('~')[0];
            if (field.global_variable_entity_field.split('~')[1]) {
              key = field.global_variable_entity_field.split('~')[1];
            }
          } else if (field.global_variable_entity_field_template_id) {
            tempId = field.global_variable_entity_field_template_id;
          }
          if (field.global_variable_entity_select_type_field_key) {
            key = field.global_variable_entity_select_type_field_key;
          }
          if (this.templateDataInfo[tempId] && key) {
            let originField = this.templateDataInfo[tempId].find((el) => el.key == key);
            if (originField?.inputType == 'SELECT') {
              return false;
            }
          }
          return true;
        }
        return true;
      }
      return true;
    },
    getLabel(item, i) {
      let selectedEntity = (this.entityDataInfo || []).find((e) => e.entity_id == item.entity_id);
      if (selectedEntity && selectedEntity.entity) {
        selectedEntity = selectedEntity.entity;
      }
      let name =
        item &&
        item.entity_prime_data &&
        Object.keys(item.entity_prime_data) &&
        item.entity_prime_data[Object.keys(item.entity_prime_data)[0]]
          ? item.entity_prime_data[Object.keys(item.entity_prime_data)[0]]
          : 'data ' + i;
      if (selectedEntity && selectedEntity.primaryFields) {
        let primaryField = selectedEntity.primaryFields[0];
        let key = primaryField && primaryField['key'] ? primaryField['key'] : null;
        if (key) {
          if (item.entity_prime_data && item.entity_prime_data[key]) {
            name = item.entity_prime_data[key + '/name']
              ? item.entity_prime_data[key + '/name']
              : item.entity_prime_data[key];
          } else {
            name =
              item.entityData &&
              primaryField.template_id &&
              item.entityData[primaryField.template_id]
                ? item.entityData[primaryField.template_id][key + '/name']
                  ? item.entityData[primaryField.template_id][key + '/name']
                  : item.entityData[primaryField.template_id][key]
                    ? item.entityData[primaryField.template_id][key]
                    : 'data' + i
                : 'data' + i;
          }
        }
      }
      return name;
    },
    allowedDataSources(filter) {
      let operatorValues = this.operatorValueTypeMap.filter((valueType) => {
        return (
          valueType.operators.indexOf(filter.operator) > -1 &&
          valueType.data_types.indexOf(filter.data_type) > -1
        );
      });

      return operatorValues.map((e) => e.value_type);
    },
    checkIsSelect(filter) {
      let field = this.getField(filter.selectField);
      if (
        field &&
        (field.inputType == 'SELECT' ||
          field.inputType == 'MULTI_SELECT' ||
          field.inputType == 'CHECKBOX_GROUP' ||
          field.inputType == 'WEEKDAYS' ||
          field.inputType == 'RADIO_BUTTON_GROUP' ||
          field.inputType == 'PAY_BUTTON' ||
          field.inputType == 'LIST' ||
          (field &&
            field.integration_settings &&
            field.integration_settings.selectedIntegrationFieldVariableType == 'select'))
      ) {
        return true;
      }
      return false;
    },
    isValidActionButton(field) {
      if (field?.actions) {
        let allowedField = (field.actions || []).find(
          (e) => e.action_button_action_type == 'TEMPLATE_ACTION'
        );
        if (allowedField) {
          return true;
        }
      }
      return false;
    },
    getField(fieldKey) {
      let field;
      if (fieldKey && fieldKey.includes('#')) {
        field = this.includeDataTableFields.find((field) => field.key == fieldKey);
      } else {
        field = [...this.allowedFields, ...this.allFields].find((field) => field.key == fieldKey);
      }
      return field;
    },
    getTypeFromInputType(inputType) {
      const obj = {
        SINGLE_LINE_TEXT: 'STRING',
        LOCATION: 'LOCATION',
        CAPTCHA: 'CAPTCHA',
        CONCATENATE: 'STRING',
        QR: 'QR',
        SLOT: 'SLOT',
        CALENDER: 'CALENDER',
        RANDOM_TEXT: 'RANDOM_TEXT',
        PARAGRAPH: 'PARAGRAPH',
        ICON: 'ICON',
        MULTI_LINE_TEXT: 'STRING',
        SINGLE_LINE_CONTENT: 'STRING',
        DATE: 'DATE',
        INTEGRATION: 'INTEGRATION',
        INTEGRATION_VARIABLE: 'VARIABLE',
        DATE_TIME: 'DATE_TIME',
        DIVISION: 'DIVISION',
        TIME: 'TIME',
        NUMBER: 'NUMBER',
        AGGREGATE_FUNCTION: 'NUMBER',
        FILE: 'FILE',
        SELECT: 'ARRAY',
        YES_OR_NO: 'BOOLEAN',
        MULTI_SELECT: 'ARRAY',
        CHECKBOX_GROUP: 'ARRAY',
        RADIO_BUTTON_GROUP: 'ARRAY',
        CHECKBOX: 'BOOLEAN',
        RADIO: 'BOOLEAN',
        LIST: 'ARRAY',
        VIDEO: 'VIDEO',
        HEADING: 'STRING',
        SIGNATURE: 'SIGNATURE',
        GLOBAL_VARIABLE: 'OBJECT_ID',
        ENTITY: 'OBJECT_ID',
        IMAGE: 'IMAGE',
        PASSWORD: 'STRING',
        MASKED: 'STRING',
        EMAIL: 'EMAIL',
        PHONE: 'NUMBER',
        ZIP_CODE: 'NUMBER',
        FAX: 'NUMBER',
        CURRENCY: 'NUMBER',
        PHONE_COUNTRY_CODE: 'PHONE',
        QUESTION: 'QUESTION',
        DATE_TIME_RANGE: 'DATE_TIME_RANGE',
        DATE_RANGE: 'DATE_RANGE',
        WEEKDAYS: 'WEEKDAYS',
        TIME_RANGE: 'TIME_RANGE',
        ACTION_BUTTON: 'ACTION',
        HYPER_LINK: 'HYPER_LINK',
        STAR_RATING: 'NUMBER',
        PAY_BUTTON: 'PAYMENT',
        DATA_TABLE: 'TABLE',
        AUTO_INCREMENT_NUMBER: 'STRING',
      };
      return obj[inputType];
    },
    async checkCurrentFieldData(fieldKey, filter) {
      filter = filter || {};
      this.selectedFieldsKey = fieldKey;
      if (fieldKey == 'compare_slots') {
        filter.data_type = 'compare_slots';
        filter.input_type = 'compare_slots';
        return;
      }
      if (fieldKey == 'apply_rules') {
        filter.data_type = 'apply_rules';
        filter.input_type = 'apply_rules';
        this.$set(filter, 'operator', '');
        this.$set(filter, 'data_source', '');
        this.$set(filter, 'value', '');
        return;
      }
      if (fieldKey == 'created_by') {
        filter.data_type = 'created_by';
        filter.input_type = 'created_by';
        return;
      }
      if (fieldKey == 'updated_by') {
        filter.data_type = 'updated_by';
        filter.input_type = 'updated_by';
        return;
      }
      if (fieldKey == 'created_at') {
        filter.data_type = 'created_at';
        filter.input_type = 'created_at';
        return;
      }
      if (fieldKey == 'updated_at') {
        filter.data_type = 'updated_at';
        filter.input_type = 'updated_at';
        return;
      }
      if (fieldKey == 'NOTIFICATION') {
        return;
      }
      if (fieldKey == 'userType') {
        filter.data_type = 'userType';
        filter.input_type = 'userType';
        return;
      }
      if (fieldKey == 'IsUserType') {
        filter.data_type = 'IsUserType';
        filter.input_type = 'IsUserType';
        return;
      }
      let field = this.allowedFields
        .concat(this.allowedContentFields)
        .find((field) => field.key == fieldKey);
      if (!field) {
        field = this.getField(fieldKey);
      }
      if (
        field &&
        field?.inputType == 'INTEGRATION' &&
        field?.integration_settings &&
        field?.integration_settings?.selectedIntegration
      ) {
        const connectionId = field?.integration_settings?.selectedIntegration;
        await this.getDetails(field, connectionId);
      }
      if (
        field &&
        field?.inputType === 'INTEGRATION' &&
        field?.integration_settings &&
        field?.integration_settings.templateDependencies &&
        field?.integration_settings.templateDependencies.length > 0
      ) {
        filter.dependencies = true;
      }

      if (field && field.inputType == 'INTEGRATION_VARIABLE') {
        this.currentRule.integrationType =
          field.integration_settings.selectedIntegrationFieldVariableType;
        filter.integrationType = field.integration_settings.selectedIntegrationFieldVariableType;
        filter.integrationField = field.integration_settings.selectedIntegrationFieldVariable;
      }
      if (field?.is_individual) {
        filter.is_individual = true;
      }
      if (field?.linked_entity_id) {
        filter.linked_entity_id = field.linked_entity_id;
      }
      if (field.input_type === 'TIME' && field.is_fixed) {
        filter.is_fixed = field.is_fixed;
      }
      if (field.input_type === 'ENTITY' && field.show_count) {
        filter.show_count = field.show_count;
      }
      if (field.input_type === 'ENTITY' && field.allow_multiple) {
        filter.allow_multiple = field.allow_multiple;
      }
      if (field.input_type == 'FORMULA' && field.result_type) {
        filter.result_type = field.result_type;
      }

      if (field.input_type === 'DATE' && field.date_view_type) {
        filter.date_view_type = field.date_view_type;
      }

      if (field?.inputType == 'SELECT' || field?.inputType == 'MULTI_SELECT') {
        filter.value = [];
      } else {
        filter.value = '';
      }
      if (field?.inputType == 'FORMULA') {
        if (field?.result_type == 'CURRENCY') {
          filter.data_type = 'NUMBER';
        } else {
          filter.data_type = field.result_type || 'NUMBER';
        }
      } else if (field?.inputType == 'PAY_BUTTON' && field.isObjField) {
        filter.data_type = this.getTypeFromInputType(field.objFieldType);
      } else {
        filter.data_type = this.getTypeFromInputType(field.inputType);
      }
      filter.input_type = field.inputType;
      if (filter.data_type == 'BOOLEAN') {
        filter.operator = '=';
      }
      if (field?.inputType == 'RELATION' || field?.data_type == 'OBJECT_ID') {
        filter.relation_entity_id = field.entity_id;
      }
      await this.getEntilistAsOptions(fieldKey);
      console.log('filter', filter);
    },
    async getEntilistAsOptions(fieldKey) {
      let field = this.getField(fieldKey);
      if (field && (field.inputType == 'ENTITY' || field.input_type == 'RELATION')) {
        await this.fetchEntityPrimaryFieldsData(field.entity_id);
      }
      await this.checkFormTemplateFields(fieldKey);
    },
    async checkFormTemplateFields(fieldKey) {
      let field = this.getField(fieldKey);
      if (
        field?.input_type == 'ENTITY_VARIABLE' &&
        field.inputType != 'ENTITY' &&
        field.global_variable_entity_field
      ) {
        let tempId = '';
        if (field.global_variable_entity_field.includes('#')) {
          tempId = field.global_variable_entity_field.split('#')[0];
        } else if (field.global_variable_entity_field.includes('~')) {
          tempId = field.global_variable_entity_field.split('~')[0];
        } else if (field.global_variable_entity_field_template_id) {
          tempId = field.global_variable_entity_field_template_id;
        }
        await this.fetchTemplateInfo(tempId);
      }
    },
    async fetchTemplateInfo(template_id) {
      if (template_id && !this.templateDataInfo[template_id]) {
        this.loading = true;

        let getSingleCompanyTemplate = await fetchSingleCompanyTemplate(template_id);
        if (getSingleCompanyTemplate) {
          this.templateDataInfo[template_id] = this.getTemplateFields(getSingleCompanyTemplate);
        }
        this.loading = false;
      }
    },
    getTemplateFields(data) {
      let fields = [];
      if (data?.sections) {
        data.sections.forEach((e) => {
          if (e.fields) {
            fields = [...fields, ...e.fields];
          }
        });

        fields = fields.map((e) => {
          e.template_id = data._id;
          e.template_name = data.name;
          e.data_type = this.getTypeFromInputType(e.inputType);
          return e;
        });
      }
      return fields;
    },
    getCurrentFieldOperators(filter) {
      const selectField = filter.selectField;
      const varField = this.allFields.find((field) => field.key === selectField);
      if (varField) {
        if (
          varField &&
          varField?.inputType == 'INTEGRATION' &&
          varField?.integration_settings &&
          varField?.integration_settings?.templateDependencies &&
          varField?.integration_settings?.templateDependencies.length
        ) {
          return [
            {
              title: 'Not Exist',
              value: 'notexists',
            },
            {
              title: 'Exist',
              value: 'exists',
            },
          ];
        }
        if (
          varField &&
          varField?.inputType == 'INTEGRATION' &&
          varField?.integration_settings &&
          varField?.integration_settings?.selectedIntegration
        ) {
          return [
            {
              title: 'In',
              value: 'in',
            },
            {
              title: 'Not In',
              value: 'nin',
            },
            {
              title: 'Not Exist',
              value: 'notexists',
            },
            {
              title: 'Exist',
              value: 'exists',
            },
          ];
        }
        if (varField?.inputType === 'INTEGRATION_VARIABLE') {
          let variable =
            varField?.integration_settings?.selectedIntegrationFieldVariableType || null;
          if (variable === 'date') {
            return [
              { title: 'Equals (=)', value: '=' },
              { title: 'Not Equals (=)', value: '!=' },
              { title: 'Greater Than (>)', value: '>' },
              { title: 'Greater Than or Equal (>=)', value: '>=' },
              { title: 'Less Than (<)', value: '<' },
              { title: 'Less Than or Equal (<=)', value: '<=' },
              { title: 'Not Exist', value: 'notexists' },
              { title: 'Exist', value: 'exists' },
              { title: 'Range', value: 'ranges' },
            ];
          } else if (variable == 'text') {
            return [
              {
                title: 'Equals (Case-sensitive)',
                value: '=case-sensitive',
              },
              {
                title: 'Not Equals (Case-sensitive)',
                value: '!=case-sensitive',
              },
              {
                title: 'Equals (Case-insensitive)',
                value: '=case-insensitive',
              },
              {
                title: 'Not Equals (Case-insensitive)',
                value: '!=case-insensitive',
              },
              {
                title: 'Starts With',
                value: '=starts-with',
              },
              {
                title: ' Not Starts With',
                value: '=not-starts-with',
              },
              {
                title: 'Ends With',
                value: '=ends-with',
              },
              {
                title: 'Not Ends With',
                value: '!ends-with',
              },
              {
                title: 'Text Includes',
                value: '=text-includes',
              },
              {
                title: 'Not Exist',
                value: 'notexists',
              },
              {
                title: 'Exist',
                value: 'exists',
              },
            ];
          } else if (variable == 'select') {
            return [
              {
                title: 'In',
                value: 'in',
              },
              {
                title: 'Not In',
                value: 'nin',
              },
              {
                title: 'Not Exist',
                value: 'notexists',
              },
              {
                title: 'Exist',
                value: 'exists',
              },
            ];
          }
        }
      }
      if (filter.selectField === 'compare_slots') {
        filter.data_type = 'compare_slots';
        filter.input_type = 'compare_slots';
        return [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ];
      }
      if (filter.selectField === 'userType') {
        filter.data_type = 'userType';
        filter.input_type = 'userType';
        return [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ];
      }
      if (filter.selectField === 'created_by') {
        filter.data_type = 'created_by';
        filter.input_type = 'created_by';
        return [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ];
      }
      if (filter.selectField === 'updated_by') {
        filter.data_type = 'updated_by';
        filter.input_type = 'updated_by';
        return [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ];
      }
      if (filter.selectField === 'IsUserType') {
        filter.data_type = 'IsUserType';
        filter.input_type = 'IsUserType';
        return [
          {
            title: 'In',
            value: 'in',
          },
          {
            title: 'Not In',
            value: 'nin',
          },
        ];
      }
      if (filter.data_type == 'created_at' || filter.data_type == 'updated_at') {
        return [
          {
            title: 'Greater Than (>)',
            value: '>',
          },
          {
            title: 'Less Than (<)',
            value: '<',
          },
        ];
      }
      if (filter.selectField) {
        let field = this.getField(filter.selectField);
        if (field && this.getTypeFromInputType(field.inputType)) {
          field.data_type = this.getTypeFromInputType(field.inputType);
        } else if (field && field.inputType == 'PAY_BUTTON' && field.isObjField) {
          field.data_type = this.getTypeFromInputType(field.objFieldType);
        }
        if (field?.inputType === 'ENTITY' && field?.show_count) {
          return [
            {
              title: 'Equals (=)',
              value: '=',
            },
            {
              title: 'Greater Than (>)',
              value: '>',
            },
            {
              title: 'Greater Than or Equal(>=)',
              value: '>=',
            },
            {
              title: 'Less Than (<)',
              value: '<',
            },
            {
              title: 'Less Than or Equal(<=)',
              value: '<=',
            },
            {
              title: 'Not Exist',
              value: 'notexists',
            },
            {
              title: 'Exist',
              value: 'exists',
            },
          ];
        }

        if (field?.inputType == 'FORMULA') {
          if (field?.result_type == 'CURRENCY') {
            field.data_type = 'NUMBER';
            return this.operatorsMap[field?.data_type];
          }
          return this.operatorsMap[field?.result_type];
        }
        return this.operatorsMap[field?.data_type];
      } else {
        return [];
      }
    },
    async getDetails(field, connectionId) {
      const integrationSettings = field?.integration_settings;
      if (!integrationSettings) {
        console.error('Integration settings are missing for field:', field);
        return;
      }
      if (
        !integrationSettings.templateDependencies ||
        (integrationSettings.templateDependencies &&
          integrationSettings.templateDependencies.length === 0)
      ) {
        const selectedEventKey = integrationSettings.selectedEvent;
        const integrationDetail = this.integrations.find(
          (integration) => integration._id === connectionId
        );
        if (!integrationDetail) {
          console.error('Integration detail not found for connectionId:', connectionId);
          return;
        }
        const predefinedIntegration = this.predefinedIntegrations?.find(
          (integration) => integration.key === integrationDetail.application.key
        );
        const Event = predefinedIntegration?.events.find(
          (event) => String(event._id) === selectedEventKey
        );
        const asset = Event?.asset;
        const requestBody = {
          selectedApplication: integrationDetail.application.key,
          selectedEvent: asset,
          selectedIntegration: integrationSettings.selectedIntegration,
          requiredFields: integrationSettings.requiredFields || {},
        };
        const apiResponse = await this.fetchEventData(requestBody, field);
        if (apiResponse.status === true) {
          this.options = apiResponse?.data || [];
        } else {
          this.options = [];
        }
      } else {
        let requiredFields = {};
        let macthedField;
        let templateDependencies = integrationSettings.templateDependencies;
        let filteredValues = templateDependencies.filter((key) => this.form[key]);
        if (templateDependencies.length === filteredValues.length) {
          await templateDependencies.forEach((dependencyKey) => {
            macthedField = this.fieldsData.find((field) => field.key == dependencyKey);
            if (macthedField) {
              let key = macthedField.integration_settings.selectedEvent;
              const predefinedIntegration = this.predefinedIntegrations.find(
                (integration) => integration._id === integrationSettings.selectedApplication
              );
              const Event = predefinedIntegration.events.find((event) => String(event._id) === key);
              const asset = Event.asset;
              this.$set(requiredFields, asset, this.form[dependencyKey]);
            }
          });

          const predefinedIntegration = this.predefinedIntegrations.find(
            (integration) => integration._id === integrationSettings.selectedApplication
          );
          const event = predefinedIntegration.events.find(
            (event) => String(event._id) === integrationSettings.selectedEvent
          );
          const connectionId = macthedField.integration_settings.selectedIntegration;
          const integrationDetail = this.integrations.find(
            (integration) => integration.connection_id === connectionId
          );
          const requestBody = {
            selectedApplication: integrationDetail.application.key,
            selectedEvent: event.asset,
            selectedIntegration: connectionId,
            requiredFields: requiredFields,
          };
          const apiResponse = await this.fetchEventData(requestBody, field);

          if (apiResponse.status === true) {
            this.options = apiResponse?.data || [];
          } else {
            this.options = [];
          }
        }
      }
    },
    async fetchEventData(requestBody, field) {
      try {
        const response = await postAPICall(
          'POST',
          `integrations/service/get-event-data`,
          requestBody
        );
        const rawData = response?.data?.data || [];

        const options = rawData?.map((item) => ({
          id: item.id,
          name: item.name,
        }));

        const isIntegrationField =
          field.inputType === 'INTEGRATION' &&
          (field.input_type === 'INTEGRATION' || field.input_type === 'ENTITY_VARIABLE');

        if (isIntegrationField) {
          const matchedCondition = this.currentRule.conditions.find(
            (condition) => condition?.selectField === field.key
          );
          if (matchedCondition) {
            this.$set(this.ruleIntegrationOptions, field.key, options);
            return options;
          }

          const matchedAction = this.currentRule.actions.find((action) => {
            const isMatch = action?.selectField === field.key;
            console.log('ismatch', isMatch);
            return isMatch;
          });

          if (matchedAction) {
            this.$set(this.actionIntegrationOptions, field.key, options);
            return options;
          }
        }

        return options;
      } catch (error) {
        console.error('Error in fetchEventData:', error);
        throw error;
      }
    },
    addGlobalVaraibleData(value, rule) {
      let selectedGlobalVariable = this.selectedGlobalVariablesList(rule).find(
        (e) => e._id == value
      );
      if (selectedGlobalVariable?.value) {
        rule.value = selectedGlobalVariable.value;
      }
    },
    selectedGlobalVariablesList(rule) {
      let data = this.globalVariablesList.filter((x) => x && x.input_type == rule.input_type);
      return data;
    },
  },
};
